import { useEffect, useState } from 'react'
import { useRemoteClientGet } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '@/remote/local-storage'

export const LoadMembers = () => {
  const [data, setData] = useState<any[]>([])
  const { getUnitId } = useLocalStorage()
  const { remoteClientGet } = useRemoteClientGet()

  useEffect(() => {
    remoteClientGet(`/alunos?page=0&size=1000&sort=id,desc&unidadeId=${getUnitId()}`)
      .then((response: any) => {
        setData(response.data.data.content)
      })
      .catch(CatchMessageError)
  }, [])

  return {
    data
  }
}
